import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import Spinner from '../ui/Spinner';
import { AuthContext } from '../../context/AuthContext';

export default function RequireAuth() {
  const { token, loading, error, clearError } = useContext(AuthContext);
  const loc = useLocation();

  // Clear any auth errors when navigating to new pages
  useEffect(() => {
    if (error) {
      clearError();
    }
  }, [loc.pathname, error, clearError]);

  if (loading) return <Spinner text="Checking login…" />;
  
  // Error handling block
  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '20px',
        padding: '20px',
        textAlign: 'center'
      }}>
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffeaa7',
          borderRadius: '8px',
          padding: '20px',
          maxWidth: '400px'
        }}>
          <h3 style={{ color: '#856404', margin: '0 0 10px 0' }}>
            Session Expired
          </h3>
          <p style={{ color: '#856404', margin: '0 0 20px 0' }}>
            {error}
          </p>
          <button
            onClick={() => window.location.href = '/login'}
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }
  
  // ============================================================================
  // UPDATED: Preserve query params when redirecting to login
  // This is critical for WooCommerce WordPress plugin flow
  // ============================================================================
  if (!token) {
    // Build the full return path including query params
    const returnPath = loc.pathname + loc.search;
    
    // Redirect to login with return_to param so user comes back after auth
    return <Navigate 
      to={`/login?return_to=${encodeURIComponent(returnPath)}`} 
      replace 
    />;
  }
  
  return <Outlet />;
}